import React, { memo } from "react";

import { makeStyles } from "@material-ui/styles";
import SvgIcon from "@material-ui/core/SvgIcon";

const useStyles = makeStyles({
  icon: {
    width: "1.125rem",
    height: "1.563rem",
    fillOpacity: "0.87",
  },
});

const RoadIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 25 15" className={styles.icon} fill="white">
      <path d="M0.992785 17.6431H9.81431L10.199 12.6173H14.1736L14.5583 17.6431H23.3799C23.5128 17.6427 23.6435 17.6097 23.7608 17.5471C23.878 17.4845 23.9781 17.3941 24.0523 17.2839C24.1265 17.1736 24.1726 17.0469 24.1865 16.9147C24.2005 16.7825 24.1818 16.649 24.1321 16.5257L17.7929 0.84297C17.6857 0.591597 17.5067 0.377487 17.2782 0.227519C17.0498 0.0775502 16.7821 -0.00159311 16.5089 2.43041e-05H13.2032L13.4483 3.34975H10.9121L11.1571 2.43041e-05H7.86377C7.58772 0.000413182 7.31806 0.083171 7.08932 0.237705C6.86057 0.392239 6.68315 0.611518 6.57975 0.867475L0.240505 16.5502C0.195888 16.6722 0.181132 16.8031 0.197471 16.932C0.213811 17.0608 0.26077 17.1839 0.334422 17.2909C0.408074 17.3979 0.506276 17.4857 0.620816 17.547C0.735355 17.6082 0.862901 17.6412 0.992785 17.6431ZM10.7553 5.36645H13.6174L13.9825 10.1227H10.3902L10.7553 5.36645Z" />
    </SvgIcon>
  );
};

export default memo(RoadIcon);
